<template>
  <ppt-modal class="grid-square-modal">
    <header slot="header">
      <button class="close" data-dismiss="modal"><span>&times;</span></button>
      <h4 class="modal-title">{{ generalHand.displayString }}</h4>
    </header>
    <section slot="body">
      <table class="specific-hands-grid">
        <tr v-for="row in specificHandsGrid">
          <td
            v-for="specificHand in row"
            v-bind:class="{
              'specific-hand-in-range': specificHand && specificHand.possible && specificHand.inRange,
              'specific-hand-possible': specificHand && specificHand.possible,
            }"
            v-on:click="toggleSpecificHandInRange(specificHand)"
          >
            <span
              v-if="specificHand && specificHand.possible"
              v-html="getHTMLForSuitIcons(specificHand.combo)"
            ></span>
            <input
              v-if="specificHand && specificHand.possible"
              type="checkbox"
              v-bind:checked="specificHand.inRange"
            >
          </td>
        </tr>
      </table>
      <hr>
      <p v-if="generalHand.maxPossibleWeight < 100" class="text-muted">
        Note: One or more combos have a max possible weight because of the weights given to these combos in the previous streets range. See <a href="https://redchippoker.com/laws-hand-reading/">the first law of hand reading</a>.
      </p>
      <table class="table table-hover specific-hands-table">
        <thead>
          <tr>
            <th>Combo</th>
            <th>In range</th>
            <th>Weight</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(specificHand, key, index) in generalHand.specificHands"
            v-bind:key="'average-specific-hand-row-' + specificHand.string"
            v-if="index === 0"
          >
            <td>Average</td>
            <td>-</td>
            <td>
              <div v-if="generalHand.possible && generalHand.inRange && generalHand.averageWeight > generalHand.maxPossibleWeight">
                <p>Average weight: {{ generalHand.averageWeight }}</p>
                <hr>
                <div>Set the weight of all combos:</div>
                <vue-slider
                  ref="slider"
                  v-bind="sliderOptions"
                  v-bind:style="'width: ' + generalHand.maxPossibleWeight + '%'"
                  v-bind:value="generalHand.averageWeight"
                  v-bind:max="generalHand.maxPossibleWeight"
                  v-on:callback="$emit('applyExactWeightToGeneralHand', { newWeight: $event, generalHandString: generalHand.string })"
                ></vue-slider>
              </div>
              <vue-slider
                v-else-if="generalHand.possible && generalHand.inRange && generalHand.averageWeight <= generalHand.maxPossibleWeight"
                ref="slider"
                v-bind="sliderOptions"
                v-bind:style="'width: ' + generalHand.maxPossibleWeight + '%'"
                v-bind:value="generalHand.averageWeight"
                v-bind:max="generalHand.maxPossibleWeight"
                v-on:callback="$emit('applyExactWeightToGeneralHand', { newWeight: $event, generalHandString: generalHand.string })"
              ></vue-slider>
            </td>
          </tr>
          <tr
            v-for="specificHand in generalHand.specificHands"
            v-bind:key="specificHand.string"
            v-if="specificHand.possible"
          >
            <td v-html="getHTMLForSuitIcons(specificHand.combo)"></td>
            <td>
              <input
                type="checkbox"
                v-bind:checked="specificHand.inRange"
                v-on:change="toggleSpecificHandInRange(specificHand)"
              >
            </td>
            <td>
              <vue-slider
                ref="slider"
                v-if="specificHand.inRange"
                v-bind="sliderOptions"
                v-bind:style="'width: ' + specificHand.maxPossibleWeight + '%'"
                v-bind:value="specificHand.weight"
                v-bind:max="specificHand.maxPossibleWeight"
                v-on:callback="$emit('setWeightOfSpecificHand', { newWeight: $event, specificHandString: specificHand.string })"
              ></vue-slider>
            </td>
          </tr>
        </tbody>
      </table>
    </section>
  </ppt-modal>
</template>

<script>
import PPTModal from '@/components/utilities/modal';
import VueSlider from 'vue-slider-component';
import utilities from '@/services/utilities/utilities';

export default {
  name: 'grid-square-modal',
  components: {
    'ppt-modal': PPTModal,
    'vue-slider': VueSlider,
  },
  props: ['generalHand'],
  data: function () {
    return {
      sliderOptions: {
        min: 5,
        interval: 5,
        tooltip: 'hover',
        debug: false, // prevents console.error stuff; I'm getting a mistaken console.error about the value being 0, which is less than the min of 5
      },
    };
  },
  computed: {
    specificHandsGrid: function () {
      let self = this;
      let suitsGrid = [
        ['cc', 'cs', 'ch', 'cd'],
        ['sc', 'ss', 'sh', 'sd'],
        ['hc', 'hs', 'hh', 'hd'],
        ['dc', 'ds', 'dh', 'dd']
      ];

      return suitsGrid.map(function (row) {
        return row.map(function (suits) {
          return self.generalHand.specificHands[suits];
        });
      });
    },
  },
  mounted: function () {
  	let self = this;

  	$(self.$el).on('shown.bs.modal', function () {
      $(self.$el).find('[data-toggle="popover"]').popover();
      self.$nextTick(function () {
        if (self.$refs.slider) {
          self.$refs.slider.forEach(function (ref) {
            ref.refresh();
          });
        }
      });
    });
    $(self.$el).on('hidden.bs.modal', function () {
      self.$emit('modalHidden');
    });
  },
  methods: {
    getHTMLForSuitIcons: function (suits) {
      return utilities.general.getHTMLForSuitIcons(suits);
    },
    toggleSpecificHandInRange: function (specificHand) {
      if (!specificHand || !specificHand.possible) {
        return;
      }

      if (specificHand.inRange) {
        this.$emit('deselectSpecificHand', specificHand.string);
      } else {
        this.$emit('selectSpecificHand', specificHand.string);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
  @import "node_modules/bootstrap-sass/assets/stylesheets/bootstrap/variables";
  @import "src/assets/mixins";

  .grid-square-modal {
    cursor: auto;
    font-style: normal;
  }

  table.specific-hands-grid {
    border-spacing: 5px;
    border-collapse: separate;
    max-width: 100%;

    td {
      text-align: center;
      vertical-align: middle;
      border-radius: 5px;
      font-size: 22px;
      width: 60px;
      height: 60px;

      @include noselect();

      &.specific-hand-possible {
        border: 1px solid lightgray;
        cursor: pointer;
      }

      &.specific-hand-in-range {
        background: lighten($gray-base, 72%);;
      }

      input[type="checkbox"] {
        display: block;
        margin: 0 auto;
      }
    }
  }

  .text-muted, .text-warning {
    margin-top: 15px;
    font-weight: bold;
  }

  .modal-title {
    text-align: left;
  }

  p {
    text-align: left;
    font-size: 12px;
  }

  table.specific-hands-table {
    font-size: 12px;

    th, td {
      vertical-align: middle;
    }

    td div {
      text-align: left;

      hr {
        margin-top: 5px;
        margin-bottom: 5px;
      }
    }

    th:first-of-type {
      width: 25px;
    }

    th:nth-of-type(2) {
      width: 65px;
    }

    span.glyphicon-question-sign {
      cursor: pointer;
    }

    @media(max-device-width: 460px) {
      th:nth-of-type(2) {
        width: 20px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/hand-range/grid-selector/grid-square-modal.vue